import styled from "styled-components";
import { setFlex, setPosition } from "../variables/utils";
import { BREAKPOINTS } from "../variables/breakpoints";

export const NavigationWrapper = styled.div`
  ${setFlex({
    align: "center",
    justify: "space-between",
    direction: "column",
  })};
  width: 100%;
  height: 100%;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ justify: "space-between" })};
    margin-bottom: 1.5rem;
  }
`;

export const NavigationAnimating = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ align: "center", justify: "center" })};
  width: 100%;
`;

export const NavigationFloat = styled.div`
  ${setFlex({ align: "center", justify: "center" })};
  height: fit-content;
`;

export const NavigationContainer = styled.div`
  ${setFlex({})};
  overflow: hidden;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 100%;
  }
`;

export const NavigationColumn = styled.div`
  ${setFlex({ direction: "column" })};
  ${props => props.$absolute && setPosition({ position: "absolute" })};
  ${props => props.$left && setPosition({ left: "0" })};
  ${props => props.$right && setPosition({ right: "0" })};
  ${props => props.$hidden && `div { visibility: hidden; }`};
  height: 100%;
`;

export const Headline = styled.h1`
  text-transform: uppercase;
  font-family: "univers-bold-cond", sans-serif;
  ${props => props.$colours && props.$colours};
  white-space: nowrap;
  margin: 1.5rem 0;
  font-size: 2.5rem;
  line-height: 2.5rem;
  ${props =>
    props.$absolute && setPosition({ position: "absolute", left: "0" })};
`;

export const NavigationImageContainer = styled.div`
  ${setFlex({ align: "center", justify: "center" })};
  height: 100%;
  padding: 1rem 0;
  svg {
    ${props => props.$hidden && `visibility: hidden;`};
    max-height: 25vh;
    width: auto;
    margin-left: ${props => (props.$hidden ? 0 : "5rem")};
    @media (max-width: ${BREAKPOINTS.sm}px) {
      margin: 0;
      max-height: 15vh;
    }
    @media (max-width: ${BREAKPOINTS.xs}px) {
      max-height: 10vh;
    }
  }
`;
